import moment from 'moment';

export const userBlockOptions: [
  moment.DurationInputArg1,
  moment.unitOfTime.DurationConstructor,
  string,
][] = [
  [1, 'day', '1_day'],
  [3, 'day', '3_day'],
  [1, 'week', '1_week'],
];

export const userContentCleanOptions: [
  moment.DurationInputArg1,
  moment.unitOfTime.DurationConstructor,
  string,
][] = [
  [1, 'day', 'after_1_day'],
  [3, 'day', 'after_3_day'],
  [1, 'week', 'after_1_week'],
  [2, 'week', 'after_2_week'],
  [1, 'month', 'after_1_month'],
  [3, 'month', 'after_3_month'],
];

export type UserBlockReason = 'AGE_LESS_THEN_13' | 'SCAM' | 'ADULT_CONTENT' | 'SPAM' | 'BAD_USER';

export const userPermanentBlockReasonOptions: UserBlockReason[] = [
  'AGE_LESS_THEN_13',
  'SCAM',
  'ADULT_CONTENT',
  'SPAM',
  'BAD_USER',
];

const options = {
  userBlockOptions,
  userContentCleanOptions,
  userPermanentBlockReasonOptions,
};

export default options;
